export default "__VITE_ASSET__Blg4E_s___"